// Local BE debugging: route ONE backend service to a locally-running worktree while
// every other service still hits the deployed cluster. Set these in your local .env
// (both empty in prod/CI, so this is a no-op there):
//
//   VITE_DEBUG_SERVICE=settings                 # the service path segment to route locally
//   VITE_DEBUG_SERVICE_URL=http://localhost:8001 # where the local worktree serves (run-be.sh prints this)
//
// The cluster gateway strips the "/api/v1/<service>" prefix before the service sees it
// (the service mounts its routers at the un-prefixed path), so we strip it here too when
// redirecting. WebSockets are intentionally NOT debug-routed — see subscription.tsx.
const DEBUG_SERVICE = (import.meta.env.VITE_DEBUG_SERVICE ?? "").trim();
const DEBUG_SERVICE_URL = (import.meta.env.VITE_DEBUG_SERVICE_URL ?? "").trim().replace(/\/$/, "");

// Loopback hosts only — exact hostname match (protocol-agnostic; excludes
// look-alikes like "localhost.example.com").
const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);
const onLocalhost = (): boolean => LOCAL_HOSTS.has(window.location.hostname);

export const getBaseUrl = (): string => {
  const hostname = window.location.origin;
  return onLocalhost() ? import.meta.env.VITE_SERVICES_URL : hostname;
};

// Build a full API URL for a route path (e.g. "/api/v1/settings/views/"). On localhost
// with a debug service configured, requests for that service are redirected to the local
// worktree with the "/api/v1/<service>" prefix stripped; everything else goes to the
// base URL (cluster gateway) unchanged.
export const buildApiUrl = (apiCall: string): string => {
  if (onLocalhost() && DEBUG_SERVICE && DEBUG_SERVICE_URL) {
    const prefix = `/api/v1/${DEBUG_SERVICE}`;
    if (apiCall.startsWith(prefix)) {
      const suffix = apiCall.slice(prefix.length);
      // Only a real segment boundary counts (so "/api/v1/settingsfoo" doesn't match);
      // "" (root), "/" (subpath), "?" (query on root) and "#" (fragment) are all valid.
      if (suffix === "" || /^[/?#]/.test(suffix)) {
        return `${DEBUG_SERVICE_URL}${suffix}`;
      }
    }
  }
  return `${getBaseUrl()}${apiCall}`;
};
